<template>
    <!-- swiper -->
    <div class="home-containers">
        <div class="col-md-12 swiper-box">
            <swiper :options="swiperOption"  class="swiper-container swiper-pagination1"  ref="mySwiper">
                <div class="swiper-slide" v-for="(item,index) in swiperItem" :key="index">
					<img :src="item.img" :alt="item.title" :title="item.title" style="width: 100%;">
				</div>
                <div class="swiper-pagination"  slot="pagination"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
export default {
  name: 'swiperBar',
  components: {
    Swiper,
    SwiperSlide,
  },
  props:{
      swiperItem:{
          type:Array,
          default:[],
      }
  },
  data () {
    return {
        
        swiperOption: {
             autoplay: {
                disableOnInteraction: false,
                delay: 3000,
            },
            pagination: {
                el: '.swiper-pagination',
            },
           
        }
      }
  },
   computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      }
    },
    mounted () {
    //   this.swiper.slideTo(0, 0, false);
    }
}
</script>




// WEBPACK FOOTER //
// src/components/swiper/Swiper.vue